'use strict';

var _ = require('lodash');
var JQXGridLatestSortService = function JQXGridLatestSortService() {
  var gridSortCriteria = {};
  function toggleSortCriteriaColumns(previousCriteria, currentCriteria) {
    var columnsToToggle;
    columnsToToggle = _.chain(currentCriteria.getActiveSortColumnFields()).transform(function (result, columnKey) {
      var activeSortColumn = previousCriteria.getActiveSortColumn(columnKey);
      if (typeof activeSortColumn !== 'undefined') {
        return result.push(activeSortColumn);
      }
    }).value();
    if (columnsToToggle.length < 1) {
      return currentCriteria;
    }
    columnsToToggle.forEach(function (column) {
      previousCriteria.getActiveSortColumn(column.field).toggleSortDirection();
    });
    return previousCriteria;
  }
  function getLatestSortCriteria(gridId) {
    return gridSortCriteria[gridId];
  }
  function addLatestSortCriteria(gridId, sortCriteria) {
    gridSortCriteria[gridId] = sortCriteria;
  }
  function hasLatestSortCriteria(gridId) {
    return getLatestSortCriteria(gridId) !== undefined;
  }
  function toggleSortColumns(previousSortCriteria, currentSortCriteria) {
    if (previousSortCriteria.isCustomSort() && !currentSortCriteria.isCustomSort()) {
      return toggleSortCriteriaColumns(previousSortCriteria, currentSortCriteria);
    }
    return currentSortCriteria;
  }
  return {
    addLatestSortCriteria: addLatestSortCriteria,
    hasLatestSortCriteria: hasLatestSortCriteria,
    getLatestSortCriteria: getLatestSortCriteria,
    toggleSortColumns: toggleSortColumns
  };
};
JQXGridLatestSortService.$inject = [];
module.exports = JQXGridLatestSortService;